import React from "react";
import buyImage from "../../../assets/buyimage.png";
import step1 from "../../../assets/step1.png";
import step2 from "../../../assets/step2.png";
import step3 from "../../../assets/step3.png";
import step4 from "../../../assets/step4.png";
import Button from "../../../components/Button";
import { FiCopy } from "react-icons/fi";
import { CopyToClipboard } from "react-copy-to-clipboard";
import toast from "react-hot-toast";
import { shortAddress } from "../../../web3/helpers";
const Buy = () => {
  class DataClass {
    constructor(image, text) {
      this.image = image;
      this.text = text;
    }
  }
  const data = [
    new DataClass(step1, "Create a wallet Example: Metamask, Trust etc"),
    new DataClass(step2, "Fund Your wallet with ETH"),
    new DataClass(step3, "Input Kings Coin address in Uniswap"),
    new DataClass(step4, "Hit ‘Swap’ on Uniswap (0.5-1% slippage recommended)"),
  ];

  return (
    <div className="buy" id="how-to-buy">
      <div className="container py-20 relative z-10">
        <h2 className="text-4xl text-center leading-[4rem] font-bold ">
          <p>How to Buy</p>
          <p className="text-primary">Kings Coin?</p>
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-20 md:mt-40">
          <div>
            <img src={buyImage} alt="" className="mx-auto" />
          </div>
          <div className="flex flex-col justify-center">
            {data.map((item, i) => (
              <div
                key={i}
                className="grid grid-cols-12 justify-start gap-2 items-center mb-2"
              >
                <div className="col-span-3">
                  <img src={item.image} className="w-28 shrink-0" alt="" />
                </div>
                <div className="col-span-8">
                  <p className="font-serif text-base md:text-xl md:max-w-[340px] w-full">
                    {item.text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="bg-black bg-opacity-10 mt-10 p-4 md:p-10 text-center font-serif">
          <h2 className="text-xl"> Kings Coin Contract Address</h2>
          <div className="flex bg-gray-700 bg-opacity-50 max-w-[600px] w-full mx-auto justify-center mt-10 items-center ">
            <input
              className="hidden sm:block  h-full px-4 text-[#72758B] bg-transparent w-full focus:outline-none"
              value={" 0xA1B26B9918b350e9657D9Ab43A45088805d65E4e"}
            />
            <input
              className=" sm:hidden  h-full px-4 text-[#72758B] bg-transparent w-full focus:outline-none"
              value={shortAddress(
                " 0xA1B26B9918b350e9657D9Ab43A45088805d65E4e"
              )}
            />
            <CopyToClipboard
              text={"0xA1B26B9918b350e9657D9Ab43A45088805d65E4e"}
              onCopy={() => toast.success("Copy to clipboard")}
            >
              <Button>
                <p>
                  <FiCopy />
                </p>
                <p>Copy</p>
              </Button>
            </CopyToClipboard>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Buy;
